import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-bank-card",
  "use": "oc-bank-card-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"oc-bank-card\"><path d=\"M893.746 289.536c0-29.204-24.051-51.536-51.536-51.536H177.395c-29.204 0-51.536 24.05-51.536 51.536v75.586h769.605l-1.718-75.586zM122.423 734.464C124.14 763.668 148.191 786 175.676 786h664.815c29.204 0 51.536-24.05 51.536-51.536V451.016H122.423v283.448z m146.019-108.226h206.144v51.536H268.442v-51.536z\" fill=\"#FF5400\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol